import { FORTA_BLACK, FORTA_BLUE, FORTA_GRAY5 } from '../../../utils/colors';

export const FORTA_CONTACT_INFO = {
  address: '548 Market Street, PMB 89605',
  city: 'San Francisco, CA 94104',
  phone: '(415) 322-8857',
  email: 'care@fortahealth.com',
};

export const FORTA_CONTACT_INFO_STYLES = { fontWeight: 600, fontSize: '14px', color: FORTA_GRAY5 };

export const FORTA_CONTACT_INFO_TITLE_STYLES = {
  fontWeight: 700,
  fontSize: '48px',
  color: FORTA_BLACK,
};

export const FORTA_CONTACT_EMAIL_STYLES = {
  ...FORTA_CONTACT_INFO_STYLES,
  color: FORTA_BLUE.bright,
  textDecoration: 'underline',
};
